import { fetch } from 'containers/ClanManagement/proxy/helpers'

export const STRONGHOLD_MANEUVERS_REQUEST = 'stronghold_maneuvers/REQUEST'
export const STRONGHOLD_MANEUVERS_SUCCESS = 'stronghold_maneuvers/SUCCESS'
export const STRONGHOLD_MANEUVERS_ERROR = 'stronghold_maneuvers/ERROR'

export function requestStrongholdManeuversInfo() {
    return async (dispatch, getState) => {
        dispatch({ type: STRONGHOLD_MANEUVERS_REQUEST })

        const { gatewayHost } = getState().settings
        const url = new URL('/wgshevents/settings/', gatewayHost).href

        if (process.env.API_ENV === 'mock') {
            return dispatch(
                {
                    type: STRONGHOLD_MANEUVERS_SUCCESS,
                    payload: require('../__mocks__/stronghold_maneuvers_mock').data,
                }
            )
        }

        try {
            const response = await fetch(url, { credentials: 'include' })
            dispatch(
                {
                    type: STRONGHOLD_MANEUVERS_SUCCESS,
                    payload: response,
                }
            )
        } catch (e) {
            dispatch({ type: STRONGHOLD_MANEUVERS_ERROR }
            )
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/stronghold_maneuvers.js